import { render } from "./Progressbar.vue?vue&type=template&id=e021803a"
import script from "./Progressbar.vue?vue&type=script&lang=js"
export * from "./Progressbar.vue?vue&type=script&lang=js"
script.render = render

export default script